import React, { useMemo, useState, useEffect } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { usePartnerUIContext } from "../PartnerUIContext";
import { initialFilter } from "../PartnerUIHelpers";

const prepareFilter = (queryParams, values) => {
  const { name } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  //add to Object filter
  filter.name = name ?? "";
  newQueryParams.filter = filter;
  return newQueryParams;
};

export const PartnerFilter = ({ listLoading }) => {
  // Partner UI Context
  const partnerUIContext = usePartnerUIContext();
  const partnerUIProps = useMemo(() => {
    return {
      setQueryParams: partnerUIContext.setQueryParams,
      queryParams: partnerUIContext.queryParams,
      filterType: partnerUIContext.filterType,
    };
  }, [partnerUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(partnerUIProps.queryParams, values);
    if (!isEqual(newQueryParams, partnerUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      partnerUIProps.setQueryParams(newQueryParams);
    }
  };

  return (
    <Formik
      initialValues={initialFilter.filter}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-4">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Search"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Cari</b> Berdasarkan Nama Opsi
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
